import get from 'lodash.get';

const getCurrentPackageName = (rootState) =>
  get(rootState, 'subscriptions.currentPackage.name', null);

export default getCurrentPackageName;
